const TEXT_INPUT_TARGETS = [
  'textBox',
  'outputController',
  'reportBuilder',
  'varInputNode',
  'richTextBox',
  'output-controller',
  'commandTextNode',
  'command-text-node',
];

const WEB_NODES = [
  'webSearch',
  'webMedia',
  'webLocations',
  'webNews',
  'webCrawling',
  'webTrends',
  'webAmazon',
];

const DATA_PROCESSING_NODES = [
  'mathFunction',
  'scripting',
  'tableProcessor',
  'outputTable',
  'apiCaller',
  'sqlQuerier',
];

const MEDIA_NODES = [
  'audioReaderNode',
  'commandMusicNode',
  'imageReaderNode',
  'animationNode',
];

const INTEGRATION_NODES = [
  'usCensusNode',
  'secApiNode',
  'documentSummarizer',
  'hubSpotCRM',
  'storedDataCaller',
];

const FLUX_NODES = ['fluxBox', 'pullData', 'pushData', 'fileSave', 'nodesAdd'];

const COMMON_DATA_TARGETS = [
  ...WEB_NODES,
  ...DATA_PROCESSING_NODES,
  ...MEDIA_NODES,
  ...INTEGRATION_NODES,
  ...FLUX_NODES,
];

const DATA_OUTPUT_SOURCES = [
  ...TEXT_INPUT_TARGETS,
  'nodesBox',
  'fluxObject',
  'voiceBoxNode',
  'arrayNode',
  'commandContentNode',
  'imageGenerator',
  'textCompressorNode',
  'outputObjectNode',
  'counterNode',
  'deepRefNode',
  'mediaBox',
  ...COMMON_DATA_TARGETS,
];

const DATA_INPUT_TARGETS = [
  ...TEXT_INPUT_TARGETS,
  'voiceBoxNode',
  'imageGenerator',
  'arrayNode',
  'conditionNode',
  'counterNode',
  'nodesBox',
  ...COMMON_DATA_TARGETS,
];

const GENERAL_DATA_TARGETS = [
  ...TEXT_INPUT_TARGETS,
  'voiceBoxNode',
  'outputObjectNode',
  'fluxObject',
  'textCompressorNode',
  'arrayNode',
  'commandContentNode',
  'nodesBox',
  'dynamicSettingsNode',
  ...COMMON_DATA_TARGETS,
];

const includesAny = (str: string | undefined, nodeTypes: string[]): boolean => {
  if (!str) return false;
  return nodeTypes.some(type => str.includes(type));
};

export const checkHandleConnectable = (params: any, edges: any[]) => {
  const { source, target, sourceHandle, targetHandle } = params;

  const foundEdge = edges?.find(
    edge =>
      edge?.source === source &&
      edge?.sourceHandle === sourceHandle &&
      edge?.target === target &&
      edge?.targetHandle === targetHandle,
  );

  if (foundEdge) {
    return false;
  }

  if (target?.includes('mediaBox') && targetHandle === 'mediaInput') {
    return true;
  }

  if (source?.includes('mediaBox') && sourceHandle === 'mediaOutput') {
    if (
      includesAny(target, TEXT_INPUT_TARGETS) ||
      includesAny(target, ['voiceBoxNode', 'arrayNode', ...COMMON_DATA_TARGETS])
    ) {
      return true;
    }
  }

  if (source?.includes('dynamicSettingsNode')) {
    if (
      includesAny(target, TEXT_INPUT_TARGETS) &&
      targetHandle === 'modelSettings'
    ) {
      return true;
    }
    if (
      target?.includes('voiceBoxNode') &&
      targetHandle === 'modelVoiceSettings'
    ) {
      return true;
    }
  }

  if (includesAny(source, DATA_OUTPUT_SOURCES)) {
    if (sourceHandle !== 'outputFlow') {
      if (includesAny(target, DATA_INPUT_TARGETS)) {
        if (targetHandle === 'input') {
          return false;
        }
        return true;
      }

      if (includesAny(target, GENERAL_DATA_TARGETS)) {
        return true;
      }
    }
  }

  if (
    sourceHandle?.includes('conditionHandle') &&
    targetHandle === 'input' &&
    !target?.includes('outputObjectNode') &&
    !target?.includes('richTextBox')
  ) {
    return true;
  }

  if (
    sourceHandle?.includes('outputHandle') &&
    targetHandle === 'input' &&
    !target?.includes('outputObjectNode') &&
    !target?.includes('richTextBox')
  ) {
    return true;
  }

  if (
    targetHandle === 'input' &&
    sourceHandle === 'outputFlow' &&
    !target?.includes('outputObjectNode') &&
    !target?.includes('richTextBox')
  ) {
    return true;
  }

  if (targetHandle === 'input' && sourceHandle === 'a') {
    return true;
  }

  if (target?.includes('nodesAdd')) {
    if (targetHandle === 'nodesInput' || targetHandle === 'edgesInput') {
      return true;
    }
  }

  return false;
};
